import { cn } from '~/lib/cn';

type HeadingLevel = 'h1' | 'h2' | 'h3';
type Alignment = 'left' | 'center';

interface SectionHeaderProps {
  eyebrow?: string;
  heading: string;
  lead?: string;
  align?: Alignment;
  as?: HeadingLevel;
  className?: string;
  [key: string]: unknown;
}

function SectionHeader({
  eyebrow,
  heading,
  lead,
  align = 'left',
  as: Tag = 'h2',
  className,
  ...rest
}: SectionHeaderProps) {
  const alignClass = align === 'center' ? 'text-center' : 'text-left';

  return (
    <div className={cn('flex flex-col gap-3', alignClass, className)} {...rest}>
      {eyebrow !== undefined && eyebrow !== '' && (
        <span
          className={cn(
            'font-display font-semibold tracking-[0.22em] uppercase text-[0.6875rem]',
            'text-[var(--color-cyan-signal)]'
          )}
        >
          {eyebrow}
        </span>
      )}

      <Tag
        className={cn(
          Tag === 'h1'
            ? 'text-[4.5rem] md:text-[6rem] font-display font-extrabold tracking-tight uppercase leading-[0.95]'
            : Tag === 'h2'
              ? 'text-4xl md:text-5xl font-display font-bold tracking-[0.03em] leading-tight'
              : 'text-xl md:text-2xl font-head font-semibold tracking-[0.05em]',
          'text-[var(--color-frost-white)]'
        )}
      >
        {heading}
      </Tag>

      {lead !== undefined && lead !== '' && (
        <p
          className={cn(
            'text-base font-body font-light leading-[1.8]',
            'text-[var(--color-steel-mist)]',
            'mt-1'
          )}
        >
          {lead}
        </p>
      )}
    </div>
  );
}

export { SectionHeader };
export type { SectionHeaderProps };
export default SectionHeader;
